import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import Loader from "../../components/Loader";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Image from "../../assets/images/bus-viala.png";
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [company, setCompany] = useState([]);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showpass, setShowPass] = useState(false);
  const [year, setYear] = useState(0);
  const [loadingLogo, setLoadingLogo] = useState(true);
  const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
  const URLZFILES = process.env.REACT_APP_API_ZFILES;
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem('dataUser');
    if (storedUser) {
      const { rol_id } = JSON.parse(storedUser);
      if (rol_id === 3) {
        navigate('/listado-boletos');
        return;
      } 
      if (rol_id === 9) {
        navigate('/mi-corrida');
        return;
      } 
      if (rol_id === 2) {
        navigate('/reporte-ganancias');
        return;
      } 
      navigate('/dashboard');
    }
    getInfoCompany();
    const current = new Date();
    const year = current.getFullYear();
    setYear(year);
  }, [navigate]);

  const showPassword = () => {
    setShowPass(!showpass);
  }

  const getInfoCompany = async () => {  
    await axios.get(ENDPOINT + 'get-company/' + 1)
      .then(response => {
        setCompany(response.data.data);
        setLoadingLogo(false);
      }).catch(function (error) {
        console.log(error);
        setLoadingLogo(false);
      });
  };

  const handleSubmit = async e => {
      e.preventDefault();
      setLoading(true);
      const form = new FormData();
      form.append('user', email);
      form.append('password', password);
      await axios.post(ENDPOINT + 'login', form)
        .then(response => {
        setLoading(false);
        const dataUser = response.data.data;
        localStorage.setItem('dataUser', JSON.stringify(dataUser));
        const { rol_id } = dataUser;
        Swal.fire({
          icon: 'success',
          title: '<h2 style="color: #033c73"><i class="fas fa-check-circle"></i> ¡Inicio de sesión exitoso!</h2>',
          html: `<p style="color: #666">${response.data.msg}</p>`,
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          background: '#fff',
          customClass: {
            popup: 'animated fadeInDown',
            title: 'text-primary'
          },
          didOpen: () => {
            Swal.showLoading();
          },
          willClose: () => {
            if (rol_id === 3) {
              window.location.href = '/admin/listado-boletos';
            } else if(rol_id === 2) {
              window.location.href = '/admin/reporte-ganancias';
            }else if(rol_id === 9) {
              window.location.href = '/admin/mi-corrida';
            }
            
            else {
              window.location.href = '/admin/dashboard';
            }
          }
        });
      }).catch(function (error) {
        console.log(error);
        setLoading(false);
        Swal.fire({
          icon: 'error',
          title: '<h2 style="color: #c71c22"><i className="fas fa-times-circle"></i> ¡Error de acceso!</h2>',
          html: `<p style="color: #666">${error.response.data.msg}</p>`,
          showConfirmButton: true,
          confirmButtonText: 'Intentar nuevamente',
          confirmButtonColor: '#dc3545',
          background: '#fff',
          customClass: {
            popup: 'animated shake',
            title: 'text-danger'
          }
        });
      });
  }; 

  return (
    <> 
      <div className="login-page d-flex align-items-center justify-content-center" style={{ height: "100vh" }}>
        {loading && <Loader />}
        <form onSubmit={handleSubmit}>
          <div className="container">
            <div className="row justify-content-md-center">
              <div className="col-xl-12 col-lg-12 col-md-9">
                <div className="card o-hidden border-0 shadow-lg my-5" style={{ display: "flex", borderRadius: "15px !important", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }}>
                  <div className="card-body p-0">
                    <div className="row">
                      <div className="col-lg-6 d-flex flex-column align-items-center justify-content-center" style={{ background: "#0f1d3a", zIndex: 99 }}>
                        <img style={{ width: "95%", marginBottom: "20px" }} className="img-responsive" src={Image} />
                        <h2 style={{ fontSize: "30px", color: "white", textAlign: "center" }}>
                          Bienvenidos <br/> 
                          Zona Administrativa
                        </h2>
                      </div>
                      <div className="col-lg-6" style={{ zIndex: 99, background: "#fcfefd" }}>
                        <div className="row">
                          <div className="col-md-12 col-md-offset-1 mt-4 text-center">
                            {loadingLogo ? (
                              <Skeleton height={180} width={200} />
                            ) : (
                              <img className="img-responsive" height={180} width={200} src={URLZFILES + company.logo_main} style={{ marginBottom: "1em" }} />
                            )}
                          </div>
                        </div>
                        <div className="col-md-12 col-md-offset-1 mt-4">
                          <div className="form-input mb-4">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <i className="far fa-user-circle"></i>
                              </span>
                            </div>
                            <input
                              id="email"
                              name="email"
                              type="email"
                              placeholder="Ingrese su email"
                              onChange={e => setEmail(e.target.value)} 
                              value={email}
                              className={`form-control form-control-sm`}
                              style={{paddingLeft: "10%"}}
                              required
                            />
                          </div>
                          <div className="form-group">
                            <div className="input-group-prepend">
                              <span className="input-group-text"><i className="fas fa-lock"></i></span>
                            </div>
                            <input
                              id="password"
                              name="password"
                              type={!showpass ? 'password' : 'text'}
                              placeholder="Ingrese su contraseña"
                              onChange={e => setPassword(e.target.value)} 
                              value={password}
                              className={`form-control form-control-sm`}
                              style={{paddingLeft: "10%"}}
                              required
                            />
                            <a 
                              onClick={showPassword}
                              style={{position:"absolute",margin:0,right:"20px",marginTop:"-21px",zIndex:"999", backgroundColor: "transparent !important", border: "none !important", cursor: "pointer"}}  
                              className="">
                              <i style={{color:"#033c73"}} className={`fas fa-eye ${!showpass ? '' : 'd-none'} `}></i>
                              <i style={{color:"#033c73"}} className={`fa-solid fa-eye-slash ${!showpass ? 'd-none' : ''} `}></i>
                            </a>
                          </div>
                          <div className="row align-items-center">
                            <div className="col-sm-4">
                                <div className="checkbox">
                                  <div className="checkbox">
                                    <label className="remember">
                                      <input 
                                        className="me-2"
                                        type="checkbox" 
                                        name="remember" 
                                        value="1" 
                                        id="remember"
                                      />
                                      Recuérdame                       
                                    </label>
                                  </div>
                                </div>
                            </div>
                            <div className="col-sm-8" style={{ textAlign: "right", marginTop: "20px", marginBottom: "25px" }}>
                              <button 
                                type="submit" 
                                className="btn btn-primary btn-lg text-white">
                                  <i className="fas fa-sign-in-alt me-2"></i>
                                  Iniciar Sesión
                              </button>
                            </div>
                          </div>
                          <div className="row mt-4">
                            <div className="col text-center">
                              <button 
                                type="button" 
                                onClick={() => window.history.back()} 
                                className="btn btn-dark btn-sm me-2">
                                  <i className="fas fa-arrow-left me-2"></i>
                                  Volver
                              </button>
                              <button 
                                type="button" 
                                className="btn btn-success btn-sm">
                                  <i className="fas fa-unlock-alt me-2"></i>
                                  Recuperar Contraseña
                              </button>
                            </div>
                          </div>
                          <div className="row mt-3">
                            <div className="col text-center">
                              <p className="copyright">
                                © {year} {company.name}. Todos los derechos reservados.
                                <br/>Versión 1.0
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default Login;